import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withDirectives as _withDirectives, vModelText as _vModelText, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/deleteIcon.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-07bbb9e2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tableCornerRadius bg-white" }
const _hoisted_2 = { class: "table-container" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "flex" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = ["onUpdate:modelValue"]
const _hoisted_7 = ["value"]
const _hoisted_8 = ["value"]
const _hoisted_9 = {
  key: 1,
  class: "w-12"
}
const _hoisted_10 = ["onUpdate:modelValue", "v-if"]
const _hoisted_11 = { key: 0 }
const _hoisted_12 = { class: "cursor-pointer empty rowHeight" }
const _hoisted_13 = ["colspan"]
const _hoisted_14 = { class: "flex items-center justify-center w-full h-16" }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { class: "cursor-pointer rowHeight" }
const _hoisted_17 = ["colspan"]
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-center" }, [
  /*#__PURE__*/_createElementVNode("p", { class: "text-xs font-normal text-black" }, "No Records Found")
], -1))
const _hoisted_19 = [
  _hoisted_18
]
const _hoisted_20 = {
  key: 2,
  class: "nonEmptyTable"
}
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { class: "text-xs" }
const _hoisted_24 = { key: 1 }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "flex justify-start items-center h-5 w-5 ml-6" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    class: "h-5 w-5 cursor-pointer"
  })
], -1))
const _hoisted_26 = [
  _hoisted_25
]
const _hoisted_27 = { key: 2 }
const _hoisted_28 = ["onMousemove"]
const _hoisted_29 = { key: 3 }
const _hoisted_30 = ["onMousemove"]
const _hoisted_31 = { key: 4 }
const _hoisted_32 = ["onMousemove"]
const _hoisted_33 = {
  key: 5,
  class: "table-ellipsis"
}
const _hoisted_34 = ["onMousemove"]
const _hoisted_35 = { key: 6 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dots_loader = _resolveComponent("dots-loader")!
  const _component_tool_tip = _resolveComponent("tool-tip")!
  const _component_pagination = _resolveComponent("pagination")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("table", null, [
        _createElementVNode("thead", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
            return (_openBlock(), _createElementBlock("th", {
              scope: "col",
              key: presentColumn,
              class: _normalizeClass(["bg-white capitalize", _ctx.headerAlignment(presentColumn)]),
              onClick: ($event: any) => (_ctx.sort(presentColumn))
            }, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", null, _toDisplayString(_ctx.getcolumnLabel(presentColumn)), 1),
                (_ctx.getcolumnLabel(presentColumn)!=='')
                  ? (_openBlock(), _createElementBlock("div", {
                      key: 0,
                      class: _normalizeClass(["sort cursor-pointer", _ctx.className == presentColumn ? _ctx.classSort : 'opacity-50'])
                    }, null, 2))
                  : _createCommentVNode("", true)
              ])
            ], 10, _hoisted_3))
          }), 128)),
          (_ctx.visibility)
            ? (_openBlock(), _createElementBlock("tr", _hoisted_5, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn, index) => {
                  return (_openBlock(), _createElementBlock("td", {
                    class: _normalizeClass(["bg-white", _ctx.getFilterSize(presentColumn)]),
                    key: index
                  }, [
                    (_ctx.isColumnArrayPresent(presentColumn))
                      ? _withDirectives((_openBlock(), _createElementBlock("select", {
                          key: 0,
                          class: _normalizeClass(["statusFilter", [_ctx.filters[presentColumn] == null ? 'inputboxstylingForSelect' : 'stylingForInputboxstylingForSelect']]),
                          "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event)
                        }, [
                          _createElementVNode("option", {
                            value: _ctx.filters.presentColumn,
                            selected: "",
                            hidden: "",
                            disabled: ""
                          }, "Select", 8, _hoisted_7),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getDropdownOptionsForFilter(presentColumn), (option) => {
                            return (_openBlock(), _createElementBlock("option", {
                              class: "optionColors",
                              key: option.value,
                              value: option.value
                            }, _toDisplayString(option.label), 9, _hoisted_8))
                          }), 128))
                        ], 10, _hoisted_6)), [
                          [_vModelSelect, _ctx.filters[presentColumn]]
                        ])
                      : (_ctx.isFilterNotNecessary(presentColumn))
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                        : _withDirectives((_openBlock(), _createElementBlock("input", {
                            key: 2,
                            type: "text",
                            class: "searchForInputBoxStyling",
                            "onUpdate:modelValue": ($event: any) => ((_ctx.filters[presentColumn]) = $event),
                            placeholder: "Search",
                            "v-if": presentColumn!=='deleteIcon'
                          }, null, 8, _hoisted_10)), [
                            [_vModelText, _ctx.filters[presentColumn]]
                          ])
                  ], 2))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ]),
        (_ctx.loadData == true)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_11, [
              _createElementVNode("tr", _hoisted_12, [
                _createElementVNode("td", {
                  class: "relative h-5",
                  colspan: _ctx.columnNames.size
                }, [
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_dots_loader)
                  ])
                ], 8, _hoisted_13)
              ])
            ]))
          : (_ctx.sortedData.length == 0)
            ? (_openBlock(), _createElementBlock("tbody", _hoisted_15, [
                _createElementVNode("tr", _hoisted_16, [
                  _createElementVNode("td", {
                    class: "relative h-10",
                    colspan: _ctx.columnNames.size
                  }, _hoisted_19, 8, _hoisted_17)
                ])
              ]))
            : (_openBlock(), _createElementBlock("tbody", _hoisted_20, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sortedData, (row, index) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: row,
                    class: "cursor-pointer rowHeight"
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columnNames, (presentColumn) => {
                      return (_openBlock(), _createElementBlock("td", {
                        key: presentColumn,
                        onMouseout: _cache[0] || (_cache[0] = ($event: any) => (_ctx.doFalse())),
                        onClick: ($event: any) => (_ctx.actionOnClickingTableRow(row, index, presentColumn)),
                        class: "cursor-pointer relative"
                      }, [
                        _createElementVNode("div", null, [
                          (_ctx.isColumnArrayPresent(presentColumn))
                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.getColumnRealtedValueFromArray(row[presentColumn],presentColumn)), 1)
                              ]))
                            : (presentColumn=='deleteIcon')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_24, _hoisted_26))
                              : (presentColumn=='userCount')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("div", {
                                      class: "pl-10",
                                      onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                    }, _toDisplayString(row[presentColumn]), 41, _hoisted_28)
                                  ]))
                                : (presentColumn=='dueDays')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                                      _createElementVNode("div", {
                                        class: "pl-6",
                                        onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                      }, _toDisplayString(row[presentColumn]), 41, _hoisted_30)
                                    ]))
                                  : (presentColumn=='courseExpiry')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                        _createElementVNode("div", {
                                          class: "pl-3",
                                          onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                        }, _toDisplayString(row[presentColumn]), 41, _hoisted_32)
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_33, [
                                        _createElementVNode("div", {
                                          onMousemove: ($event: any) => (_ctx.toolTip(presentColumn, $event, index, row, 'text'))
                                        }, _toDisplayString(row[presentColumn]), 41, _hoisted_34)
                                      ])),
                          (_ctx.pop == true && _ctx.sortedData[_ctx.tipIndex][presentColumn] == _ctx.tipText && _ctx.tipColumn == presentColumn && _ctx.tipIndex == index)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_35, [
                                _createVNode(_component_tool_tip, {
                                  columnName: presentColumn,
                                  tipText: _ctx.tipText,
                                  styling: _ctx.styling
                                }, null, 8, ["columnName", "tipText", "styling"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ], 40, _hoisted_21))
                    }), 128))
                  ]))
                }), 128))
              ]))
      ])
    ]),
    _createVNode(_component_pagination, {
      dynamicPagination: _ctx.dynamicPagination,
      onCurrentPageUpdate: _ctx.paginationUpdations,
      sortedData: _ctx.sortedData
    }, null, 8, ["dynamicPagination", "onCurrentPageUpdate", "sortedData"])
  ]))
}